import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import ArchivedWorkflowList from "./ArchivedWorkflowList";

export default function ArchivedWorkflowsPage() {
  return (
    <DashboardLayout activeTab="Workflows">
      <ArchivedWorkflowList />
    </DashboardLayout>
  );
}
